import { __decorate } from "tslib";
import { extractUserId, rtfm } from '@twurple/common';
import { BaseApi } from "../BaseApi.mjs";
import { ChatBadgeList } from "./ChatBadgeList.mjs";
/**
 * The API methods that deal with badges.
 *
 * Can be accessed using `client.badges` on an {@ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient(new StaticAuthProvider(clientId, accessToken));
 * const cheermotes = await api.badges.getGlobalBadges();
 * ```
 */
let BadgesApi = class BadgesApi extends BaseApi {
    /**
     * Retrieves all globally applicable chat badges.
     *
     * @param language The language of the retrieved badge descriptions.
     */
    async getGlobalBadges(language) {
        const data = await this._client.callApi({
            url: 'https://badges.twitch.tv/v1/badges/global/display',
            query: {
                language
            },
            type: 'custom'
        });
        return new ChatBadgeList(data.badge_sets);
    }
    /**
     * Retrieves all applicable chat badges for a given channel.
     *
     * @param channel The channel to retrieve the chat badges for.
     * @param includeGlobal Whether to include global badges in the result list.
     * @param language The language of the retrieved badge descriptions.
     */
    async getChannelBadges(channel, includeGlobal = true, language) {
        const data = await this._client.callApi({
            url: `https://badges.twitch.tv/v1/badges/channels/${extractUserId(channel)}/display`,
            query: {
                language
            },
            type: 'custom'
        });
        const channelBadges = new ChatBadgeList(data.badge_sets);
        if (includeGlobal) {
            return (await this.getGlobalBadges(language))._merge(channelBadges);
        }
        return channelBadges;
    }
};
BadgesApi = __decorate([
    rtfm('api', 'BadgesApi')
], BadgesApi);
export { BadgesApi };
